/* eslint-disable dot-notation */
import React, {useState, useEffect} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Pdf from "react-to-pdf";
import './pdfStyle.css';
import moment from 'moment/moment';
import axios from 'axios';
import { LoadingButton } from '@mui/lab';
import { Grid, Container, Typography, Link, Stack, Button, Card, TextField, Checkbox, FormControlLabel, Autocomplete, InputLabel, MenuItem, FormControl } from '@mui/material';
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';

import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Icon from '@mui/material/Icon';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts'; 
import JSON_CONST from '../../../components/CONSTVALUE.json';
const ref = React.createRef();

// Register fonts
pdfMake.vfs = pdfFonts.pdfMake?.vfs || pdfFonts.vfs;

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#FFFFFF',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));
export default function PDFRenderLoanRegistrationCaseHandledBy() { 
    const params = useParams();
    const navigate = useNavigate();
    const [resData, setResData] = useState([]);
    const [paramsData, setParamsData] = useState(params.data ? JSON.parse(decodeURI(params.data)) : {});

    useEffect(() => {
        axios.post(`${JSON_CONST.DB_URL}disbursal/registrationBTGlobalREport`, paramsData)
            .then((response) => {
                console.log("Fetched Data:", response.data); // Debugging
                response.data.sort((a, b) => a.bankName.name.localeCompare(b.bankName.name));
                setResData(response.data);
            })
            .catch((error) => console.error("Error fetching data:", error));
    }, [paramsData]);

  const exportToPdf = () => {
    if (!resData || resData.length === 0) {
        alert("No data available to export!");
        return;
    }

    // Format dates
    const formattedFromDate = paramsData?.from ? moment(paramsData.from).format("DD-MM-YYYY") : "N/A";
    const formattedToDate = paramsData?.to ? moment(paramsData.to).format("DD-MM-YYYY") : "N/A";

    // Determine Ledger Type
    let ledgerType = "";
    if (paramsData?.loanLedger) {
        ledgerType = "Loan Ledger";
    } else if (paramsData?.regiLedger) {
        ledgerType = "Registration Ledger";
    }

    // Define Table Headers
    const tableHeaders =
        ledgerType === "Loan Ledger"
            ? [
                  { text: "Sr", style: "tableHeader" },
                  { text: "Registration Date", style: "tableHeader" },
                  { text: "Bank", style: "tableHeader" },
                  { text: "Branch", style: "tableHeader" },
                  { text: "Aps No", style: "tableHeader" },
                  { text: "Customer Name", style: "tableHeader" },
                  { text: "Phone No", style: "tableHeader" },
                  { text: "Property Details", style: "tableHeader" },
                  { text: "Loan Taken From", style: "tableHeader" },
                  { text: "Handled By", style: "tableHeader" },
                  { text: "Case Close", style: "tableHeader" }
              ]
            : [
                  { text: "Sr", style: "tableHeader" },
                  { text: "Registration Date", style: "tableHeader" },
                  { text: "Bank", style: "tableHeader" },
                  { text: "Branch", style: "tableHeader" },
                  { text: "Aps No", style: "tableHeader" },
                  { text: "Seller", style: "tableHeader" },
                  { text: "Purchaser", style: "tableHeader" },
                  { text: "Register Off", style: "tableHeader" },
                  { text: "Handled By", style: "tableHeader" },
                  { text: "Case Close", style: "tableHeader" }
              ];

    // Prepare Table Data
    const tableBody = [
        tableHeaders, // Headers
        ...resData.map((row, index) => [
            { text: index + 1, style: "tableCell" },
            { text: row.registrationDate ? moment(row.registrationDate).format("DD-MM-YYYY") : "N/A", style: "tableCell" },
            { text: row.bankName?.name || "N/A", style: "tableCell" },
            { text: row.branchName?.name || "N/A", style: "tableCell" },
            { text: row.applicationNo || "", style: "tableCell" },
            ...(ledgerType === "Loan Ledger"
                ? [
                      { text: row.customerName || "", style: "tableCell" },
                      { text: row.phoneNo || "", style: "tableCell" },
                      { text: row.propertyDetails || "", style: "tableCell" },
                      { text: row.loanTakenFrom || "", style: "tableCell" }
                  ]
                : [
                      { text: row.seller || "", style: "tableCell" },
                      { text: row.purchaser || "", style: "tableCell" },
                      { text: row.registrarOffName?.name || "", style: "tableCell" }
                  ]),
            { text: row.handledByName || "", style: "tableCell" },
            { text: row.caseCloseVal || "", style: "tableCell" }
        ])
    ];

    // PDF Definition
    const docDefinition = {
        pageOrientation: "landscape",
        pageSize: "A4",
        content: [
            { text: "INTELLECTIVE LAW OFFICES", style: "header" },
            { text: "Advocates, Legal Advisers & Consultants", style: "subheader" },
            { text: ledgerType ? `Ledger Type: ${ledgerType}` : "", style: "subheader" },
            { text: `FROM: ${formattedFromDate} | TO: ${formattedToDate}`, style: "subheader" },
            { text: `Number of Cases: ${resData.length}`, style: "subheader" },
            {
                style: "tableExample",
                table: {
                    widths: new Array(tableHeaders.length).fill("auto"),
                    body: tableBody
                },
                layout: {
                    hLineWidth: () => 0.5,
                    vLineWidth: () => 0.5,
                    paddingLeft: () => 2,
                    paddingRight: () => 2,
                    paddingTop: () => 2,
                    paddingBottom: () => 2
                }
            }
        ],
        styles: {
            header: { fontSize: 16, bold: true, alignment: "center" },
            subheader: { fontSize: 10, bold: true, alignment: "center" },
            tableExample: { margin: [0, 5, 0, 10] },
            tableHeader: { bold: true, fontSize: 9, alignment: "center", fillColor: "#eeeeee" },
            tableCell: { fontSize: 8, alignment: "center" }
        }
    };

    pdfMake.createPdf(docDefinition).download("Cash Handled Report.pdf");
};

const exportToExcel = () => {
    if (!resData || resData.length === 0) {
        alert("No data available to export!");
        return;
    }

    // Format dates
    const formattedFromDate = moment(paramsData?.from).format("DD-MM-YYYY");
    const formattedToDate = moment(paramsData?.to).format("DD-MM-YYYY");

    // Determine Ledger Type
    let ledgerType = "";
    if (paramsData?.loanLedger) {
        ledgerType = "Loan Ledger";
    } else if (paramsData?.regiLedger) {
        ledgerType = "Registration Ledger";
    }

    // Define Excel Headers
    const titleRow = ["Export INTELLECTIVE LAW OFFICES | Advocates, Legal Advisers & Consultants"];
    const dateRow = [`FROM: ${formattedFromDate} | TO: ${formattedToDate}`];
    const caseHandledByRow = [`Number of Cases: ${resData.length}`];
    const emptyRow = [ledgerType ? `Ledger Type: ${ledgerType}` : ""];

    // Define Table Headers
    const tableHeaders =
        ledgerType === "Loan Ledger"
            ? ["Sr", "Registration Date", "Bank", "Branch", "Aps No", "Customer Name", "Phone No","Propery Details","Loan Taken From ", "Handled By", "Case Close"]
            : ["Sr", "Registration Date", "Bank", "Branch", "Aps No", "Seller","Seller Phone no","Purchaser","Purchaser Phone no","property Details","Register Off", "Handled By", "Case Close"];

    // Prepare Table Data
    const tableData = resData.map((row, index) => [
        index + 1,
        row.registrationDate ? moment(row.registrationDate).format("DD-MM-YYYY") : "",
        row.bankName?.name || "",
        row.branchName?.name || "",
        row.applicationNo || "",
        ledgerType === "Loan Ledger" ? row.customerName || "" : row.seller || "",
        ledgerType === "Loan Ledger" ? row.phoneNo || "" : row.phone || "",
        ledgerType === "Loan Ledger" ? row.propertyDetails || "": row.purchaser || "",
        ledgerType === "Loan Ledger" ? row.loanTakenFrom || "": row.phoneMobile || "",
        ledgerType === "Loan Ledger" ? row.handledByName || "": row.propertyDetails || "",
        ledgerType === "Loan Ledger" ? row.caseCloseVal || "": row.registrarOffName?.name || "",
        ledgerType === "Loan Ledger" ? "": row.handledByName || "",
        ledgerType === "Loan Ledger" ? "": row.caseCloseVal || "",
    ]);

    // Combine All Data
    const dataXLSX = [titleRow, dateRow, caseHandledByRow, emptyRow, tableHeaders, ...tableData];

    // Generate Excel File
    const ws = XLSX.utils.aoa_to_sheet(dataXLSX);
    const wb = { Sheets: { Report: ws }, SheetNames: ["Report"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });

    FileSaver.saveAs(data, "CashHandledReport.xlsx");
};

    const redirectPage = (url) => {
        navigate(`/app/${url}`, { replace: true });
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Button 
                        style={{ backgroundColor: 'black', color: 'white' }} 
                        onClick={() => redirectPage('reportDisbursal/loanRegistrationCaseHandledBy/0')} 
                        size="medium"
                    > 
                        ← Back
                    </Button>
                </Grid>
                {/* PDF Export */}
                <Grid item xs={6}>
                    <Card style={{ backgroundColor: '#B14019' }} sx={{ minWidth: 345 }}>
                        <CardContent>
                            <PictureAsPdfOutlinedIcon style={{ fontSize: '140px', color: 'white' }} />
                            <Typography gutterBottom variant="h5" component="div" style={{ color: 'white' }}>
                                PDF EXPORT 
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button style={{ backgroundColor: '#F9F9F9' }} onClick={exportToPdf} size="small">PDF</Button>
                            &nbsp;&nbsp;&nbsp;<sub style={{ color: '#F9F9F9' }}>Click to open/download</sub>
                        </CardActions>
                    </Card>
                </Grid>

                {/* Excel Export */}
                <Grid item xs={6}>
                    <Card style={{ backgroundColor: '#1C9F44' }} sx={{ minWidth: 345 }}>
                        <CardContent>
                            <FileDownloadOutlinedIcon style={{ fontSize: '140px', color: 'white' }} />
                            <Typography gutterBottom variant="h5" component="div" style={{ color: 'white' }}>
                                XLSX EXPORT
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button style={{ backgroundColor: '#F9F9F9' }} onClick={exportToExcel} size="small">XLSX</Button>
                            &nbsp;&nbsp;&nbsp;<sub style={{ color: '#F9F9F9' }}>Click to open/download</sub>
                        </CardActions>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
}
